module.exports = __webpack_public_path__ + "static/media/Soumyadeep Anand.eee9b62b.png";